import algoliasearch from 'algoliasearch';

export function initAlgoliaClient(appId, apiKey) {
  return algoliasearch(appId, apiKey);
}